import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Scrollspy from 'react-scrollspy';
import Mixpanel from 'utils/mixpanelService';

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    right: 0,
    top: '50%',
    width: 40,
    background: 'rgba(0, 0, 0, 0.4)',
    padding: 10,
    zIndex: 9999,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    opacity: 1,
    marginTop: -110,
    display: 'flex',
    flexDirection: 'column',
  },
  marker: {
    borderRadius: 7,
    height: 7,
    width: 7,
    margin: 7,
    cursor: 'pointer',
    backgroundColor: 'hsla(0, 0%, 100%, 0.5)',
    '&.is-current': {
      backgroundColor: '#FFFFFF !important',
    },
  },
});

function SectionNavigator({ onClick }) {
  const classes = useStyles();

  const hashes = [
    'hero',
    'for-individuals',
    'stats-section',
    'solutions-section',
    'resources-section',
    'team-section',
    'app-section',
    'quote-section',
    'cta',
  ];

  return (
    <Scrollspy
      componentTag="div"
      items={hashes}
      currentClassName="is-current"
      className={classes.container}
      offset={-170}
      onUpdate={el =>
        Mixpanel.track('Solutions Home Page - Scrolled', {
          section: el.id,
        })
      }
    >
      {hashes.map(hash => (
        <div
          onClick={() => onClick(hash, 'side-navigator')}
          role="button"
          tabIndex="0"
          aria-label={hash}
          className={classes.marker}
          key={hash}
        />
      ))}
    </Scrollspy>
  );
}

SectionNavigator.propTypes = {
  onClick: PropTypes.func,
};

export default SectionNavigator;
